import { CURRENCY_MINOR_UNITS } from "@/data/currencyUnits";
import { toCurrencyCode } from "./toCurrencyCode";

// Minor units the payment APIs send per major unit, by code or symbol;
// `undefined` for a currency we haven't confirmed.
export const resolveMinorUnits = (currency?: string): number | undefined => {
  const code = toCurrencyCode(currency);

  if (!code) return undefined;

  return CURRENCY_MINOR_UNITS[code];
};
